import { useStore } from 'vuex'
import { PAGE_ANALYTICS_INFO } from '../page-types'
import type { RouteLocationNormalized } from 'vue-router'

/* ------- MICROFRONT - ORDERS ------- */

export const ordersRoutes = [
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@b2ag/micro-front-orders/app'),
    props: () => ({
      microFrontName: 'orders',
      viewName: 'ordersForTech',
      techId: useStore().getters.user.technical_sale_information.uuid,
    }),
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ORDERS,
    },
  },
  {
    path: '/account/pay-invoices',
    name: 'pay-invoices',
    component: () => import('@b2ag/micro-front-orders/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'orders',
      viewName: 'pay-invoices',
      invoiceIds: String(route.query.invoiceIds).split(','),
      orderId: route.query.orderId,
    }),
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ORDERS,
    },
  },
  {
    path: '/customer/:membershipNumber/orders/:orderId',
    name: 'order-detail-tech',
    component: () => import('@b2ag/micro-front-orders/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'orders',
      viewName: 'orderForTech',
      orderId: route.params.orderId,
      techId: useStore().getters.user.technical_sale_information.uuid,
    }),
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ORDER_DETAILS,
    },
  },
]
